import { useTranslation } from 'react-i18next'
import { Check } from '@mui/icons-material'
import { Alert, Box, List, ListItem, ListItemIcon, ListItemText, ListSubheader } from '@mui/material'

const classes = {
    listItemIconRoot: {
        minWidth: 'initial',
        paddingRight: 1.5,
    },
}

const FileRequirementsList = () => {
    const { t } = useTranslation()

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}
        >
            <List
                subheader={
                    <ListSubheader
                        color="primary"
                        disableSticky
                    >
                        {t('File Requirements')}
                    </ListSubheader>
                }
                disablePadding
            >
                <ListItem dense>
                    <ListItemIcon sx={classes.listItemIconRoot}>
                        <Check color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        id="upload-2d-dxf-dwg-files"
                        primary={t('Upload 2D DXF or DWG files')}
                    />
                </ListItem>

                <ListItem dense>
                    <ListItemIcon sx={classes.listItemIconRoot}>
                        <Check color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        id="fully-enclosed-parts"
                        primary={t('Ensure each part in the file is fully enclosed')}
                    />
                </ListItem>

                <ListItem dense>
                    <ListItemIcon sx={classes.listItemIconRoot}>
                        <Check color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        id="convert-etching-text"
                        primary={t('Convert any etching text to shapes/outlines')}
                    />
                </ListItem>

                <ListItem dense>
                    <ListItemIcon sx={classes.listItemIconRoot}>
                        <Check color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        id="connect-shapes-with-bridges"
                        primary={t('Connect shapes and text with bridges')}
                    />
                </ListItem>

                <ListItem>
                    <Alert
                        id="drawing-doctor-recommendation"
                        severity="info"
                    >
                        {t(
                            'Use the Drawing Doctor if you need to fix scaling, split multi-part files, or remove unwanted lines or borders.'
                        )}
                    </Alert>
                </ListItem>
            </List>
        </Box>
    )
}

export default FileRequirementsList
